export default __webpack_public_path__ + "static/media/prox_webinar.0687f353.svg";